import { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import { Button, Card, Input, Modal, useToast } from '../shared/UI';

export function CountersPanel() {
  const [counters, setCounters] = useState([]);
  const [modal, setModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ name: '', label: '' });
  const { show, ToastContainer } = useToast();

  const load = () => api.get('/api/counters/').then(setCounters);
  useEffect(() => { load(); }, []);

  const openCreate = () => { setEditing(null); setForm({ name: '', label: '' }); setModal(true); };
  const openEdit = (c) => { setEditing(c); setForm({ name: c.name, label: c.label }); setModal(true); };

  const save = async () => {
    if (!form.name.trim()) return show('Name is required', 'error');
    if (editing) {
      await api.put(`/api/counters/${editing.id}`, form);
      show('Counter updated');
    } else {
      await api.post('/api/counters/', form);
      show('Counter created');
    }
    setModal(false);
    load();
  };

  const toggle = async (c) => {
    await api.put(`/api/counters/${c.id}`, { is_active: !c.is_active });
    show(`Counter ${c.is_active ? 'disabled' : 'enabled'}`);
    load();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
      <ToastContainer />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 28, color: 'var(--navy)' }}>Counters</h1>
          <p style={{ color: 'var(--gray-500)', marginTop: 4, fontSize: 14 }}>Manage service counters and stations</p>
        </div>
        <Button onClick={openCreate} size="md">+ New Counter</Button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 16 }}>
        {counters.map(c => (
          <div key={c.id} className="animate-fade" style={{
            background: '#fff', borderRadius: 'var(--radius-lg)', padding: 24,
            border: `2px solid ${c.is_active ? 'var(--cobalt-bright)' : 'var(--gray-100)'}`,
            opacity: c.is_active ? 1 : 0.6, boxShadow: 'var(--shadow-sm)', transition: 'var(--transition)',
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 16 }}>
              <div style={{ width: 48, height: 48, background: c.is_active ? 'var(--cobalt)' : 'var(--gray-300)', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: 16, color: '#fff' }}>
                {c.label}
              </div>
              <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 11, fontWeight: 700, background: c.is_active ? 'rgba(0,200,83,0.12)' : 'var(--gray-100)', color: c.is_active ? 'var(--green-dark)' : 'var(--gray-500)', fontFamily: 'var(--font-display)', textTransform: 'uppercase' }}>
                {c.is_active ? 'Active' : 'Disabled'}
              </span>
            </div>
            <div style={{ fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: 17, color: 'var(--navy)', marginBottom: 4 }}>{c.name}</div>
            <div style={{ fontSize: 12, color: 'var(--gray-500)', fontFamily: 'var(--font-mono)', marginBottom: 20 }}>ID #{c.id}</div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Button onClick={() => openEdit(c)} variant="ghost" size="sm" style={{ flex: 1 }}>Edit</Button>
              <Button onClick={() => toggle(c)} variant={c.is_active ? 'danger' : 'success'} size="sm" style={{ flex: 1 }}>
                {c.is_active ? 'Disable' : 'Enable'}
              </Button>
            </div>
          </div>
        ))}
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title={editing ? 'Edit Counter' : 'New Counter'}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <Input label="Counter Name" value={form.name} onChange={v => setForm(f => ({ ...f, name: v }))} placeholder="e.g. Counter 1" required />
          <Input label="Label / Code" value={form.label} onChange={v => setForm(f => ({ ...f, label: v }))} placeholder="e.g. C1" />
          <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
            <Button onClick={() => setModal(false)} variant="ghost" style={{ flex: 1 }}>Cancel</Button>
            <Button onClick={save} style={{ flex: 1 }}>Save Counter</Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
